import { memo, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { Option, Select } from '../components/inputs/Select';
import { useLanguageOptions } from '../hooks/useLanguageOptions';
import { LanguageContext } from '../translation/src/context/LanguageContext';

const PublicLayout_: React.FC2 = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const languageOptions = useLanguageOptions();

  return (
    <div className="relative h-full">
      <div className="absolute z-10 top-4 right-4">
        <Select value={language} onChange={(event) => setLanguage(event.target.value)} className="w-36">
          {languageOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </div>
      <Outlet />
    </div>
  );
};

export const PublicLayout = memo(PublicLayout_);
